export default function IntroScreen() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] text-center">
      <div className="inline-flex items-center gap-1.5 bg-kakao text-text-primary text-xs font-bold px-3.5 py-1.5 rounded-full mb-6">
        <span>ACCU-Z</span>
        <span className="w-1 h-1 bg-text-primary rounded-full" />
        <span>BEAUTY CARE</span>
      </div>

      <h1 className="text-2xl font-bold text-text-primary leading-snug mb-3">
        피부 맞춤 케어를 위한<br />사전 설문
      </h1>

      <p className="text-sm text-text-secondary leading-relaxed mb-3">
        총 6개 섹션 · 약 2분 소요
      </p>
      <p className="text-xs text-text-secondary/70">
        중간 저장 가능 · 응답은 안전하게 보관돼요
      </p>
    </div>
  );
}